const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const generateHubTaskUrl = (parameters) => {
  const { tasktype, action, root = ROOT, integration = 'microsoft' } = parameters

  return `${root}/hub/${integration}/${tasktype}/${action}`
}
